import { get } from 'utils/api';

export const getSubscription = (data) => {
  return get(`/subscriptions`, data);
};

export const subscription = {
  getSubscription,
};
